<template>
    <div class="container">
        <div class="checkbox-outer" @click="toggle()">
            <div class="checkbox" :class="active">
                <awesome-icon icon="minus" class="icon" v-if="active === 'half'"></awesome-icon>
                <awesome-icon icon="check" class="icon" v-else></awesome-icon>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "sc-table-checkbox",
    props: ['status'],

    computed: {
      active() {
        return this.status;
      }
    },

    methods: {
      toggle() {
        this.$emit('toggle')
      }
    }
  }
</script>

<style scoped lang="scss">
    .container {
        position: relative;
        height: 100%;
        width: 100%;
        margin-left: -15px;
    }

    .checkbox-outer {
        height: 50px;
        width: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border-radius: 100px;
        position: absolute;
        top: 50%;
        left: 0;
        margin-top: -26px;
        color: #fff;
        transition: background .15s ease-in-out;
    }

    .checkbox-outer:hover {
        /*background: rgba(0, 0, 0, 0.1);*/
    }

    .checkbox {
        width: 18px;
        height: 18px;
        border: 2px solid #333;
        border-radius: 3px;
        box-sizing: border-box;
        transition: border .2s ease-in-out;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
    }

    .checkbox .icon {
        font-size: 10px;
    }

    .checkbox.half,
    .checkbox.active {
        border: 9px solid $color-primary;
    }
</style>